import { District } from '../types';

// Odisha Districts and Blocks data
export const ODISHA_DISTRICTS: District[] = [
  {
    name: 'Angul',
    blocks: ['Angul', 'Athamallik', 'Banarpal', 'Chhendipada', 'Jarapada', 'Kaniha', 'Kishorenagar', 'Pallahara']
  },
  {
    name: 'Balangir',
    blocks: ['Agalpur', 'Balangir', 'Belpada', 'Deogaon', 'Gudvella', 'Khaprakhol', 'Loisinga', 'Muribahal', 'Patnagarh', 'Puintala', 'Saintala', 'Titlagarh', 'Tureikela', 'Bangomunda']
  },
  {
    name: 'Balasore',
    blocks: ['Balasore', 'Bhograi', 'Jaleswar', 'Nilgiri', 'Oupada', 'Remuna', 'Soro', 'Simulia', 'Khaira', 'Bahanaga', 'Baliapal', 'Basta']
  },
  {
    name: 'Bargarh',
    blocks: ['Ambabhona', 'Attabira', 'Bargarh', 'Bhatli', 'Bijepur', 'Barpali', 'Bheden', 'Gaisilet', 'Jharbandh', 'Padampur', 'Paikmal', 'Sohela']
  },
  {
    name: 'Bhadrak',
    blocks: ['Bhadrak', 'Bonth', 'Chandabali', 'Dhamnagar', 'Tihidi', 'Basudevpur', 'Bhandaripokhari']
  },
  {
    name: 'Boudh',
    blocks: ['Boudh', 'Harbhanga', 'Kantamal']
  },
  {
    name: 'Cuttack',
    blocks: ['Athagarh', 'Badamba', 'Banki', 'Baranga', 'Cuttack Sadar', 'Dampara', 'Kantapada', 'Kisannagar', 'Mahanga', 'Narasinghpur', 'Niali', 'Nischintakoili', 'Salepur', 'Tangi-Choudwar', 'Tigiria']
  },
  {
    name: 'Deogarh',
    blocks: ['Barkote', 'Deogarh', 'Reamal']
  },
  {
    name: 'Dhenkanal',
    blocks: ['Bhuban', 'Dhenkanal Sadar', 'Gondia', 'Hindol', 'Kamakhyanagar', 'Kankadahad', 'Odapada', 'Parjang']
  },
  {
    name: 'Gajapati',
    blocks: ['Gumma', 'Kashinagar', 'Mohana', 'Nuagada', 'Paralakhemundi', 'Rayagada', 'R.Udayagiri']
  },
  {
    name: 'Ganjam',
    blocks: ['Aska', 'Bellaguntha', 'Berhampur', 'Bhanjanagar', 'Buguda', 'Chatrapur', 'Chhatrapur', 'Chikiti', 'Digapahandi', 'Ganjam', 'Hinjilicut', 'Jarada', 'Kabisuryanagar', 'Khallikote', 'Kukudakhandi', 'Patrapur', 'Polasara', 'Purushottampur', 'Rangeilunda', 'Sanakhemundi', 'Sheragada', 'Sorada', 'Tarava']
  },
  {
    name: 'Jagatsinghpur',
    blocks: ['Balikuda', 'Biridi', 'Erasama', 'Jagatsinghpur', 'Kujang', 'Naugaon', 'Raghunathpur', 'Tirtol']
  },
  {
    name: 'Jajpur',
    blocks: ['Bari', 'Binjharpur', 'Dasarathpur', 'Danagadi', 'Jajpur', 'Korei', 'Rasulpur', 'Sukinda']
  },
  {
    name: 'Jharsuguda',
    blocks: ['Jharsuguda', 'Kirmira', 'Lakhanpur', 'Laikera', 'Kolabira']
  },
  {
    name: 'Kalahandi',
    blocks: ['Bhawanipatna', 'Dharamgarh', 'Golamunda', 'Jaipatna', 'Junagarh', 'Kegaon', 'Kesinga', 'Kokasara', 'Lanjigarh', 'M.Rampur', 'Narla', 'Thuamul Rampur', 'Karlamunda']
  },
  {
    name: 'Kandhamal',
    blocks: ['Baliguda', 'Chakapada', 'Daringbadi', 'G.Udayagiri', 'Khajuripada', 'Kotagarh', 'Nuagaon', 'Phiringia', 'Phulbani', 'Raikia', 'Tikabali', 'Tumudibandha']
  },
  {
    name: 'Kendrapara',
    blocks: ['Aul', 'Derabish', 'Garadpur', 'Kendrapara', 'Mahakalapada', 'Marsaghai', 'Pattamundai', 'Rajkanika', 'Rajnagar']
  },
  {
    name: 'Kendujhar',
    blocks: ['Anandpur', 'Banspal', 'Barbil', 'Champua', 'Ghatagaon', 'Harichandanpur', 'Hatadihi', 'Joda', 'Karanjia', 'Kendujhar', 'Patna', 'Saharpada', 'Telkoi']
  },
  {
    name: 'Khordha',
    blocks: ['Balianta', 'Balipatna', 'Begunia', 'Bhubaneswar', 'Bolagarh', 'Chilika', 'Jatni', 'Khordha', 'Tangi']
  },
  {
    name: 'Koraput',
    blocks: ['Bandhugaon', 'Boipariguda', 'Dasmantpur', 'Jeypore', 'Koraput', 'Kotpad', 'Lamtaput', 'Laxmipur', 'Narayanpatna', 'Nandapur', 'Pottangi', 'Kundra', 'Semiliguda', 'Borigumma']
  },
  {
    name: 'Malkangiri',
    blocks: ['Chitrakonda', 'Kalimela', 'Khairput', 'Korukonda', 'Kudumulugumma', 'Malkangiri', 'Mathili', 'Podia']
  },
  {
    name: 'Mayurbhanj',
    blocks: ['Badasahi', 'Bangriposi', 'Baripada', 'Betanoti', 'Betnoti', 'Bisoi', 'Gopabandhunagar', 'Jashipur', 'Kaptipada', 'Karanjia', 'Khunta', 'Kuliana', 'Kusumi', 'Morada', 'Rairangpur', 'Rasgovindpur', 'Samakhunta', 'Saraskana', 'Sukruli', 'Thakurmunda', 'Tiring', 'Udala']
  },
  {
    name: 'Nabarangpur',
    blocks: ['Chandahandi', 'Dabugaon', 'Jharigaon', 'Kosagumuda', 'Nabarangpur', 'Nandahandi', 'Papadahandi', 'Raighar', 'Tentulikhunti', 'Umerkote']
  },
  {
    name: 'Nayagarh',
    blocks: ['Bhapur', 'Daspalla', 'Gania', 'Khandapada', 'Nayagarh', 'Nuagaon', 'Odagaon', 'Ranpur']
  },
  {
    name: 'Nuapada',
    blocks: ['Boden', 'Khariar', 'Komna', 'Nuapada', 'Sinapali']
  },
  {
    name: 'Puri',
    blocks: ['Astarang', 'Brahmagiri', 'Delang', 'Gop', 'Kakatpur', 'Kanas', 'Krushnaprasad', 'Nimapara', 'Pipili', 'Puri', 'Sadar', 'Satyabadi']
  },
  {
    name: 'Rayagada',
    blocks: ['Ambadola', 'Bissamcuttack', 'Chandrapur', 'Gudari', 'Gunupur', 'Kalyansinghpur', 'Kashipur', 'Kolnara', 'Muniguda', 'Padmapur', 'Rayagada']
  },
  {
    name: 'Sambalpur',
    blocks: ['Bamra', 'Dhankauda', 'Jamankira', 'Jujomura', 'Kuchinda', 'Maneswar', 'Naktideul', 'Rairakhol', 'Rengali', 'Sambalpur', 'Tan']
  },
  {
    name: 'Sonepur',
    blocks: ['Birmaharajpur', 'Dunguripali', 'Sonepur', 'Tarva', 'Ullunda']
  },
  {
    name: 'Sundargarh',
    blocks: ['Balisankara', 'Bargaon', 'Bisra', 'Bonai', 'Gurundia', 'Hemgiri', 'Kuarmunda', 'Kutra', 'Lahunipara', 'Lefripada', 'Lephripara', 'Nuagaon', 'Rajgangpur', 'Raghunathpali', 'Subdega', 'Sundargarh', 'Tangarpali']
  }
];

// Helper functions
export const formatDate = (date: Date | null | undefined): string => {
  // Handle null, undefined, or invalid dates
  if (!date) {
    return 'N/A';
  }
  
  // Ensure it's a valid Date object
  const validDate = date instanceof Date ? date : new Date(date);
  
  // Check if the date is valid
  if (isNaN(validDate.getTime())) {
    return 'Invalid Date';
  }
  
  return new Intl.DateTimeFormat('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(validDate);
};

export const formatDateTime = (date: Date | string | null | undefined): string => {
  // Handle null, undefined, or invalid dates
  if (!date) {
    return 'N/A';
  }
  
  // Ensure it's a valid Date object
  const validDate = date instanceof Date ? date : new Date(date);
  
  // Check if the date is valid
  if (isNaN(validDate.getTime())) {
    return 'Invalid Date';
  }
  
  return new Intl.DateTimeFormat('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }).format(validDate);
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const validateFileType = (file: File, allowedTypes: string[]): boolean => {
  if (!file) return false;
  if (file.type && allowedTypes.includes(file.type)) return true;
  
  const fileName = file.name || '';
  const ext = '.' + fileName.split('.').pop()?.toLowerCase();
  
  for (const type of allowedTypes) {
    const cleanType = type.trim().toLowerCase();
    if (cleanType.startsWith('.') && cleanType === ext) return true;
    if (cleanType === 'image/jpeg' && (ext === '.jpg' || ext === '.jpeg')) return true;
    if (cleanType === 'image/jpg' && (ext === '.jpg' || ext === '.jpeg')) return true;
    if (cleanType === 'image/png' && ext === '.png') return true;
    if (cleanType === 'application/pdf' && ext === '.pdf') return true;
    if (cleanType === 'image/*' && (file.type?.startsWith('image/') || ['.jpg', '.jpeg', '.png', '.webp'].includes(ext))) return true;
  }
  return false;
};

export const validateFileSize = (file: File, maxSizeInMB: number): boolean => {
  const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
  return file.size <= maxSizeInBytes;
};

export const generateApplicationId = (): string => {
  const timestamp = Date.now().toString();
  const random = Math.random().toString(36).substring(2, 8);
  return `KO${timestamp}${random}`.toUpperCase();
};

export const getDistrictBlocks = (districtName: string): string[] => {
  const district = ODISHA_DISTRICTS.find(d => d.name === districtName);
  return district ? district.blocks : [];
};

export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  delay: number
): ((...args: Parameters<T>) => void) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export const scrollToElement = (elementId: string, offset: number = 80): void => {
  const element = document.getElementById(elementId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

export const generateSecurityCode = (appId: string): string => {
  if (!appId) return 'XXXX';
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // Avoid ambiguous characters
  let hash = 0;
  for (let i = 0; i < appId.length; i++) {
    hash = appId.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32bit integer
  }
  let result = '';
  let tempHash = Math.abs(hash);
  for (let i = 0; i < 4; i++) {
    result += chars.charAt(tempHash % chars.length);
    tempHash = Math.floor(tempHash / chars.length);
  }
  return result;
};

export const isFormNumber1To100 = (val?: string | number | null): boolean => {
  if (val === undefined || val === null) return false;
  const str = String(val).trim();
  if (!str) return false;
  const num = parseInt(str, 10);
  return !isNaN(num) && num >= 1 && num <= 100;
};

/**
 * Extracts standard 11-character YouTube video ID from various link formats:
 * - https://www.youtube.com/watch?v=VIDEO_ID
 * - https://m.youtube.com/watch?v=VIDEO_ID
 * - https://youtube.com/live/VIDEO_ID?feature=share
 * - https://youtu.be/VIDEO_ID
 * - https://www.youtube.com/embed/VIDEO_ID
 * - https://www.youtube.com/shorts/VIDEO_ID
 * - Raw 11-char ID
 */
export const extractYouTubeVideoId = (urlOrId?: string | null): string | null => {
  if (!urlOrId) return null;
  const trimmed = urlOrId.trim();
  if (!trimmed) return null;

  // Direct 11-character ID check
  if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) {
    return trimmed;
  }

  const regExp = /(?:youtube\.com\/(?:watch\?v=|live\/|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
  const match = trimmed.match(regExp);
  return match && match[1] ? match[1] : null;
};

/**
 * Normalizes any YouTube URL or ID into a canonical YouTube watch URL.
 */
export const normalizeYouTubeUrl = (urlOrId?: string | null): string => {
  const videoId = extractYouTubeVideoId(urlOrId);
  return videoId ? `https://www.youtube.com/watch?v=${videoId}` : (urlOrId || '').trim();
};

/**
 * Returns thumbnail image URL for a YouTube video.
 */
export const formatYouTubeThumbnailUrl = (urlOrId?: string | null, quality: 'default' | 'mqdefault' | 'hqdefault' = 'hqdefault'): string => {
  const videoId = extractYouTubeVideoId(urlOrId);
  if (!videoId) return '';
  return `https://img.youtube.com/vi/${videoId}/${quality}.jpg`;
};

/**
 * Returns responsive iframe embed URL for YouTube.
 */
export const getYouTubeEmbedUrl = (urlOrId?: string | null): string | null => {
  const videoId = extractYouTubeVideoId(urlOrId);
  if (!videoId) return null;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1&origin=${encodeURIComponent(origin)}&rel=0&playsinline=1&modestbranding=1`;
};